export default __webpack_public_path__ + "static/img/weareregi.ada7917.jpg";